import React from "react";
import { HARVEST_LEGEND } from "../../mock";

const MONTHS = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
const FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const tone = { 0: "bg-[#10271a]/5 text-[#10271a]/30", 1: "bg-[#b08a5f]/40 text-[#10271a]", 2: "bg-[#1f4a33] text-[#f6f1e7]" };

export default function HarvestCalendar({ commodity, harvest }) {
  const legend = HARVEST_LEGEND[commodity];
  const now = new Date().getMonth();
  return (
    <div data-testid="harvest-calendar">
      <div className="grid grid-cols-12 gap-1.5">
        {harvest.map((level, i) => (
          <div key={i} title={`${FULL[i]} · ${legend[level] || "Off season"}`} className={`relative aspect-square rounded-lg flex items-center justify-center text-[11px] font-semibold ${tone[level]}`}>
            {MONTHS[i]}
            {i === now && <span className="absolute -bottom-2 h-1 w-1 rounded-full bg-[#7c5230]" />}
          </div>
        ))}
      </div>
      <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-[11px] tracking-[0.12em] uppercase text-[#5e6b61]">
        {[2, 1].map((l) => <span key={l} className="inline-flex items-center gap-2"><span className={`h-3 w-3 rounded ${tone[l].split(" ")[0]}`} />{legend[l]}</span>)}
        <span className="inline-flex items-center gap-2"><span className="h-1 w-1 rounded-full bg-[#7c5230]" />Now</span>
      </div>
    </div>
  );
}
